import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import './body.component.scss';


@Component({
    selector: 'mw-content-document-body',
    template: `
        <div class="mw-content-document-body" ng-repeat="text in ::$ctrl.text" ng-bind-html="::$ctrl.applyFilters(text)" mw-truncate="$ctrl.truncationLength"></div>
    `
})
export class BodyComponent implements OnInit {
    @Input('<') text: string[];
    @Input('<') truncationLength: number;

    constructor(@Inject('$filter') private $filter, @Inject('$sce') private $sce) {
        'ngInject';
    }

    ngOnInit() {
    }

    applyFilters(text) {
        const mwSanitizeInvalidHtml = this.$filter('mwSanitizeInvalidHtml');
        text = mwSanitizeInvalidHtml(text, true);
        return this.$sce.trustAsHtml(text);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/body/body.component.ts